const primaryLayout = () =>
`
  <Button>Primary</Button>
  <Button disabled>Primary</Button>
`;

const primaryLayoutSmall = () =>
`
  <Button classes="small">Primary</Button>
  <Button classes="small" disabled>Primary</Button>
`;

const secondaryLayout = () =>
`
  <Button classes="secondary">Secondary</Button>
  <Button disabled classes="secondary">Secondary</Button>
`;

const secondaryLayoutSmall = () =>
`
  <Button classes="small secondary">Secondary</Button>
  <Button disabled classes="small secondary">Secondary</Button>
`;

const exceptionCancelLayout = () =>
`
  <Button classes="special">Default</Button>
`;

const exceptionNextLayout = () =>
`
  <Button classes="special next">Default</Button>
  <Button disabled classes="special next">Default</Button>
`;

const buttonsTemplates = {
  primary        : primaryLayout(),
  primarySmall   : primaryLayoutSmall(),
  secondary      : secondaryLayout(),
  secondarySmall : secondaryLayoutSmall(),
  exceptionCancel: exceptionCancelLayout(),
  exceptionNext  : exceptionNextLayout(),
};

export default buttonsTemplates;



// WEBPACK FOOTER //
// ./src/containers/elements/Buttons/constants/buttonsTemplates.js